/** The Standaardteksten admin screen (#177): quick-select phrases, curated per boekje veld. */
export const standaardteksten = {
  toevoegen: "Standaardtekst toevoegen",
  wijzigen: "Wijzigen",
  verwijderen: "Verwijderen",
  verwijderVraag: "Standaardtekst verwijderen?",
  verwijderDescription: "Je kunt dit niet ongedaan maken.",
  /** Its own wording, not a repeat of the row's "Verwijderen": the two buttons are visible at
      the same time once the dialog is open. */
  verwijderConfirm: "Ja, verwijderen",
  submitToevoegen: "Toevoegen",
  tekst: "Tekst",
  leeg: "Nog geen standaardteksten voor dit veld.",

  errors: {
    ophalen: "Kon de standaardteksten niet ophalen.",
    toevoegen: "Kon de standaardtekst niet toevoegen.",
    opslaan: "Kon de standaardtekst niet opslaan.",
    verwijderen: "Kon de standaardtekst niet verwijderen.",
  },
} as const;
